<template>
  <EditAccount />
</template>

<script>
import { defineComponent } from "vue";

// Components
import EditAccount from "../components/EditAccount/EditAccount.vue";

export default defineComponent({
  components: {
    EditAccount,
  },
});
</script>
